import React, { useState } from 'react'
import { Box } from '@chakra-ui/react'

import SharedModal from '~components/shared/modals/shared-modal'
import { ClinicFieldsFragment } from '~graphql/generated/graphql'
import ClientSearchContent from './client-search-content'
import { useClinic } from '~contexts/clinic-context'
import ClinicGroupClinicSelect from '~components/shared/clinic-group-clinic-select'
import { useStateWithReset } from '~utils/hooks/use-state-with-reset'
import { OnSelectArgs, SearchModalType } from './types'
import PatientSearchContent from './patient-search-content'

interface Props {
    isOpen: boolean
    onClose: () => void
    onSelect: (args: OnSelectArgs) => void
    type: SearchModalType
    showReminderPdfAction: boolean
}

export default function ClientSearchModal({
    isOpen,
    onClose,
    onSelect,
    type,
    showReminderPdfAction,
}: Props) {
    const { clinic: contextClinic, clinicGroup } = useClinic()
    const [clinic, setClinic, resetClinic] = useStateWithReset<
        ClinicFieldsFragment | undefined
    >(contextClinic)

    const clinicToUse = clinic || contextClinic

    function handleClose() {
        resetClinic()
        onClose()
    }

    function handleSelect(args: OnSelectArgs) {
        onSelect(args)
        handleClose()
    }

    return (
        <SharedModal
            size="3xl"
            isOpen={isOpen}
            onClose={handleClose}
            title={
                type === SearchModalType.Client
                    ? 'Search Clients'
                    : 'Search Patients'
            }
            scrollBehavior="inside"
        >
            {clinicGroup && (
                <Box w="full" mb={4}>
                    <ClinicGroupClinicSelect
                        clinicGroup={clinicGroup}
                        clinic={clinic}
                        setClinic={setClinic}
                    />
                </Box>
            )}
            {clinicToUse &&
                (type === SearchModalType.Client ? (
                    <ClientSearchContent
                        onSelect={handleSelect}
                        clinic={clinicToUse}
                    />
                ) : (
                    <PatientSearchContent
                        onSelect={handleSelect}
                        clinic={clinicToUse}
                        showReminderPdfAction={showReminderPdfAction}
                    />
                ))}
        </SharedModal>
    )
}
